import { useCallback } from 'react'
import type { ChangeEvent } from 'react'
import { MenuItem } from '@mui/material'
import SelectV2 from '../../Common/Form/SelectV2'
import type { SelectV2Props } from '../../Common/Form/SelectV2'
import type { ProductSortType } from '../../UserData/_stores/UserPrefsStore'

export type AccountSortType = ProductSortType
export type AccountDateSortType = Extract<ProductSortType, 'n-to-o' | 'o-to-n'>

export interface AccountSortOption<TSort extends string = AccountSortType> {
  value: TSort
  label: string
}

interface Props<TSort extends string = AccountSortType> {
  label?: string
  value: TSort
  options: Array<AccountSortOption<TSort>>
  onChange: (value: TSort) => void
  SelectBaseProps?: SelectV2Props['SelectBaseProps']
}

export default function AccountSortFilter<TSort extends string = AccountSortType>(props: Props<TSort>) {
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.value as TSort)
  }, [props.onChange])

  const renderOption = useCallback((option: AccountSortOption<TSort>) => {
    return <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
  }, [])

  return <SelectV2
    label={props.label}
    value={props.value}
    onChange={onChange}
    SelectBaseProps={props.SelectBaseProps}
  >
    {props.options.map(renderOption)}
  </SelectV2>
}
